import React, { useState } from "react";
import useUpdateVesselImages from "../Utils/useUpdateVesselImages";
import { ToastContainer, toast } from "react-toastify";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { AiOutlineClose } from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import "./updatevessel.css";

const UpdateVesselImagesForm = ({ vesselId }) => {
  const { mutate: updateVesselImage, isLoading: isUpdatingImages} = useUpdateVesselImages();

  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [collapsedSections, setCollapsedSections] = useState({
    vesselImages: true,
  });

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setImages((prevImages) => [...prevImages, ...files]);

    const previews = files.map((file) => URL.createObjectURL(file));
    setImagePreviews((prevPreviews) => [...prevPreviews, ...previews]);
  };

  const handleRemoveImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setImagePreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    updateVesselImage(
      { vesselId, images },
      {
        onSuccess: () => {
          toast.success("Vessel images updated successfully!");
          setImages([]);
          setImagePreviews([]);
        },
        onError: (error) => {
          toast.error(`Error updating vessel images: ${error.message}`);
        },
      }
    );
  };

 

  const toggleSection = (section) => {
    setCollapsedSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  return (
    <div className="update-vessel-container">
      <div className="pri" onClick={() => toggleSection("vesselImages")}>
        <p>Vessel Images</p>
        {collapsedSections.vesselImages ? (
          <IoIosArrowDown />
        ) : (
          <IoIosArrowUp />
        )}
      </div>
      {!collapsedSections.vesselImages && (
        <form onSubmit={handleSubmit}>
          <label htmlFor="image-picker" className="image-picker-label">
            <img
              src="https://i.ibb.co/MBfbwGm/Frame-1171277781.png"
              alt="Picker"
              className="image-picker"
            />
          </label>
          <input
            id="image-picker"
            type="file"
            multiple
            onChange={handleImageChange}
            required
            style={{ display: "none" }}
          />
          <div className="image-preview-container">
            {imagePreviews.map((preview, index) => (
              <div key={index} className="image-preview-wrapper">
                <img src={preview} alt={`Preview ${index}`} className="image-preview" />
                <button
                  type="button"
                  className="image-remove-button"
                  onClick={() => handleRemoveImage(index)}
                >
                  <AiOutlineClose />
                </button>
              </div>
            ))}
          </div>
          <button type="submit" disabled={isUpdatingImages}>
            {isUpdatingImages ? "Updating..." : "Update Images"}
          </button>
        </form>
      )}
      <ToastContainer />
    </div>
  );
};

export default UpdateVesselImagesForm;
